// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";

import App from "@/components/app";
import router from "@/router";
import store from "@/store";
import vueCookies from "vue-cookies";
import vueAnalytics from "vue-analytics";
import { TRACKER_SETTINGS, TRACKER_DATA } from "@/common/consts";
import { isFeatureEnabled } from "@/common/feature-toggling";
import SweetModal from "sweet-modal-vue/src/plugin.js";
import wordfinder from "@/common/wordfinder";
import { API_SERVICE, DICTIONARIES_IN_API } from "@/common/consts";

import i18n from "@/common/multilanguage/i18n";

import ExperimentOverride from "@/components/experiment-override";
import "./mixins";
import { isEmpty, isClientSide } from "@/common/functions";
import {
	initAnalytics,
	trackCLS,
	trackFID,
	trackLCP,
	trackFCP,
} from "@lovetoknow/ltk-analytics";
import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";
import { readDictionary } from "@/common/functions";

import nodeConfig from "../package.json";

Vue.use(vueCookies);
Vue.use(SweetModal);
if (
	typeof window.__PRERENDER_INJECTED === "undefined" &&
	typeof window.__TEST__ == "undefined"
) {
	const analytics = initAnalytics({
		appName: "wfw",
		expTrack: true,
		pageTrack: true,
		version: nodeConfig.version,
		debug: isFeatureEnabled("debugCoreVitals"),
	});
	window.$ltkAnalytics = analytics;
}
Vue.component("ExperimentOverride", ExperimentOverride);

Sentry.init({
	Vue,
	dsn:
		"https://58946c1c3d9247ae82a9d1393043a74c@o507418.ingest.sentry.io/5874025",
	autoSessionTracking: true,
	integrations: [new Integrations.BrowserTracing()],

	// We recommend adjusting this value in production, or using tracesSampler
	// for finer control
	tracesSampleRate: 0.05,
});

const preloadUnscrambleResult = () => {
	const URL = window.location.href;
	const UNSCRAMBLE_PATH = "/unscramble/";
	const TILES = URL.split(UNSCRAMBLE_PATH)
		.pop()
		.replace(/\//g, "");
	const ORDERED_TILES = TILES.split("")
		.sort()
		.join("");

	const defaultDictionary = readDictionary("WWF");

	if (URL.includes(UNSCRAMBLE_PATH) && !isEmpty(ORDERED_TILES)) {
		const QUERY = `${API_SERVICE}/v1/unscrambler`;
		const params = {
			tiles: ORDERED_TILES,
			offset: 0,
			limit: 10,
			order_by: "score",
			group_by: "word_length",
			dictionary: defaultDictionary,
			bonus: true,
			dictionary_opt: "YDR",
			augment_results: "min_5_add_1",
		};

		if (
			!TILES.includes("_") &&
			defaultDictionary != DICTIONARIES_IN_API.ALL
		) {
			params.check_exact_match = true;
			params.exclude_original = true;
			params.original_tiles = TILES;
		}

		return wordfinder.get(QUERY, {
			params,
		});
	}
};

preloadUnscrambleResult();

if (
	typeof window.__PRERENDER_INJECTED === "undefined" &&
	typeof window.__TEST__ == "undefined"
) {
	if (isFeatureEnabled("trackCoreVitals")) {
		trackCLS();
		trackFID();
		trackLCP();
		trackFCP();
	}

	if (typeof window.__TEST__ === "undefined") {
		Vue.use(vueAnalytics, {
			id: () => {
				return Object.values(TRACKER_DATA);
			},
			customIdFields: TRACKER_SETTINGS,
			router,
			ignoreRoutes: ["/dynamic-page/"],
			// autoTracking: {
			//     pageviewOnLoad: true
			// },
			ready() {
				Vue.$ga.set("dimension1", window.appVersion);
			},
			debug: {
				enabled:
					process.env.NODE_ENV !== "production" &&
					isFeatureEnabled("EnableGADebug"),
			},
		});
	}
}
document.addEventListener("DOMContentLoaded", function() {
	/* eslint-disable no-new */
	new Vue({
		el: "#app",
		router,
		store,
		i18n,
		components: { App },
		template: "<App/>",
	});
});
